import { combineReducers } from 'redux';
import { sharedReducers } from 'lib/reducers';
import modalReducer from './modal';
import redirectReducer from './redirect';
import darkModeReducer from './isDarkModeEnabled';
import payeeSlice from 'lib/slices/payeeSlice';
import api from 'lib/services/api';
import { logoutCustomerIOUser } from '../utils/customerIO';
import { logoutSuccess } from 'lib/actions';

const reducers = {
    modalReducer,
    redirectReducer,
    darkModeReducer,
    payeeSlice,
    [api.reducerPath]: api.reducer,
    ...sharedReducers,
};

export const appReducer = combineReducers(reducers);

export type RootState = {
    [K in keyof typeof reducers]: ReturnType<typeof reducers[K]>;
};

const rootReducer = (state, action) => {
    if (action.type === logoutSuccess.type) {
        logoutCustomerIOUser();
        const { darkModeReducer } = state;
        state = { darkModeReducer };
    }

    return appReducer(state, action);
};

export default rootReducer;
